/**
 * @class away.pool.MaterialPool
 */
var MaterialPool = (function () {
    /**
     * //TODO
     *
     * @param materialClassGL
     */
    function MaterialPool(elementsClass, materialGroup) {
        this._abstractionPool = new Object();
        this._elementsClass = elementsClass;
        this._materialGroup = materialGroup;
        this._abstractionClassPool = materialGroup.abstractionClassPool;
    }
    Object.defineProperty(MaterialPool.prototype, "elementsClass", {
        get: function () {
            return this._elementsClass;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MaterialPool.prototype, "materialGroup", {
        get: function () {
            return this._materialGroup;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * //TODO
     *
     * @param elementsOwner
     * @returns IElements
     */
    MaterialPool.prototype.getAbstraction = function (material) {
        return (this._abstractionPool[material.id] || (this._abstractionPool[material.id] = new this._abstractionClassPool[material.assetType](material, this)));
    };
    /**
     * //TODO
     *
     * @param elementsOwner
     */
    MaterialPool.prototype.clearAbstraction = function (material) {
        delete this._abstractionPool[material.id];
    };
    return MaterialPool;
}());
export { MaterialPool };



// WEBPACK FOOTER //
// ../dist/lib/materials/MaterialPool.js